const base = import.meta.env.VITE_BACKEND_URL ? import.meta.env.VITE_BACKEND_URL : 'http://localhost:3001';
const basePath = `v1/auth`;

export function loginRequest(email: string, password: string) {
  return new Promise((resolve, reject) => {
    fetch(`${base}/${basePath}/manager-login`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include', // Don't forget to specify this if you need cookies
      body: JSON.stringify({ email, password }),
    }).then(async (response) => {
      const data = await response.json();
      if (response.ok) {
        resolve(data);
      } else {
        reject(data);
      }
    });
  });
}

export function logoutRequest() {
  return new Promise((resolve, reject) => {
    fetch(`${base}/${basePath}/manager-logout`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    })
      .then((result) => {
        console.log('logoutRequest', result);
        resolve(result);
      })
      .catch((error) => {
        console.log('API Auth manager-logout error', error);
        const msg = `${error.message}. `;
        if (error.response) {
          // Request made and server responded
          reject(`${msg}. ${error.response.data.message}`);
        } else if (error.request) {
          // The request was made but no response was received
          reject(`${msg}. ${error.request}`);
        } else {
          // Something happened in setting up the request that triggered an Error
          reject(`${msg}.`);
        }
      });
  });
}
